export const toggleRights = (selected, toggledRights, selectedRights) => {
  const rights = selected
    ? [...selectedRights, ...toggledRights]
    : filterRemovedRights(selectedRights, toggledRights);

  return removeDuplicatesFromArray(rights);
};

const filterRemovedRights = (selectedRights, removedRights) =>
  selectedRights.filter((right) => !removedRights.includes(right));

const removeDuplicatesFromArray = (array) => Array.from(new Set(array));
